export function objectToQueryString(obj = {}, prefix = '') {
  return Object.keys(obj)
    .map((key) => {
      const value = obj[key]
      const newKey = prefix ? `${prefix}[${key}]` : key

      if (typeof value === 'object' && value !== null) {
        return objectToQueryString(value, newKey)
      }
      return `${encodeURIComponent(newKey)}=${encodeURIComponent(value)}`
    })
    .filter(Boolean)
    .join('&')
}
